import React, { Component }  from 'react';
import PropTypes      from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { countryCityActions } from '../../redux/actions/countryCityActions';
import { isNull } from 'util';
import loader from '../../style/loader/loader.scss';


const propTypes = {
  countries: PropTypes.array.isRequired
};

let cityItems=[], isLoading='false'; let countrybg="", statebg="",citybg="";
class CountryStateCity extends Component {
  static propTypes= {
    onSelectedCountry: PropTypes.func,
    onSelectedState: PropTypes.func,
    onSelectedCity: PropTypes.func,
    stateitem: PropTypes.string,
    countryerror: PropTypes.string,
    stateerror: PropTypes.string,
    cityerror:PropTypes.string
  };
  constructor (props) {
    super(props);
    this.state ={
      countryData:[],
      statesName:[],
      citiesData:[],
      country:'',
      city:'',
      cityID:'',
      state:'',
      stateName:'',
      countryName:'',
      countrybg:'',
      statebg:'',
      citybg:'',
    }
    this.handlesOnCountryChanged=this.handlesOnCountryChanged.bind(this);
    this.handlesOnStateChanged=this.handlesOnStateChanged.bind(this);
    this.handlesOnCityChanged=this.handlesOnCityChanged.bind(this);
  }
  handlesOnCountryChanged(e){
    isLoading='true';
    this.setState({[e.target.name]:e.target.value});
    this.setState({countrybg:""});
    const selectedCountry = this.state.countryData.find(k => k.country == e.target.value);
    this.setState({countryName:selectedCountry.countryName});
    this.props.dispatch(countryCityActions.getStateData(e.target.value, localStorage.getItem("siteID")));
  } 
  handlesOnStateChanged(e){
    isLoading='true';
    this.setState({statebg:""});
    this.setState({[e.target.name]:e.target.value});
    const selectedState = this.state.statesName.find(k => k.stateAbbr == e.target.value);
    this.setState({stateName:selectedState.state});
    try{
      this.props.dispatch(countryCityActions.get_city_ByState(e.target.value, localStorage.getItem("siteID")));
    }
    catch (error) {
      alert('error:', error);
    }
  }
  
  handlesOnCityChanged(e){
    this.setState({citybg:""});
    this.setState({city:e.target.value});
    const selectedCity = this.state.citiesData.find(k => k.title == e.target.value);
    if(typeof selectedCity == 'undefined'){
      this.setState({cityID: ''});
    }else{
      this.setState({cityID:selectedCity.cityID});
    }
    
  }
  componentWillMount(){
    const { dispatch } = this.props;
    dispatch(countryCityActions.get_country_data(localStorage.getItem("siteID")));

    if(this.props.countries){
      this.setState({countryData:this.props.countries});
      this.setState({country:this.props.country, countryName:this.props.countryName});
  
      if(this.props.country){
        this.props.dispatch(countryCityActions.getStateData(this.props.country, localStorage.getItem("siteID")));
        this.setState({statesName:this.props.states});
        this.setState({state:this.props.stateAbbr, stateName:this.props.state})    
      }


    }

    if(this.props.state){
      this.props.dispatch(countryCityActions.get_city_ByState(this.props.stateAbbr, localStorage.getItem("siteID")));
      this.setState({citiesData:this.props.cityDetailsByState });
      this.setState({city:this.props.city, cityID:this.props.cityID});
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.countryerror !== nextProps.countryerror){
      nextProps.countryerror== "true"?  this.setState({countrybg:"red"}):  this.setState({countrybg:""});
    }
    if(this.props.stateerror !== nextProps.stateerror){
      nextProps.stateerror=="true"? this.setState({statebg:"red"}):  this.setState({statebg:""});
    }
    if(this.props.cityerror !== nextProps.cityerror){
      nextProps.cityerror=="true"?  this.setState({citybg:"red"}):  this.setState({citybg:""}); 
    }
    if(this.props.country !== nextProps.country){
     if(nextProps.country && typeof nextProps.country !== "undefined"){
        this.props.dispatch(countryCityActions.getStateData(nextProps.country, localStorage.getItem("siteID")));
        this.setState({state:nextProps.stateAbbr, stateName:nextProps.state,country:nextProps.country, citiesData: [], cityID:nextProps.cityID}) 
      }else{
        this.setState({state:"", stateName:"",country:"", citiesData: [], cityID:""}) 
      }
    }

    if (this.props.countries !== nextProps.countries){
      if(this.props.country){
        this.props.dispatch(countryCityActions.getStateData(this.props.country, localStorage.getItem("siteID")));
        this.setState({state:this.props.stateAbbr, stateName:this.props.state,country:this.props.country}) 
      }
      this.setState({countryData:nextProps.countries});
    }

    if (this.props.states !== nextProps.states) {
      if(this.props.stateAbbr){
        this.props.dispatch(countryCityActions.get_city_ByState(this.props.stateAbbr, localStorage.getItem("siteID")));
        this.setState({city:this.props.city,cityID: this.props.cityID, citiesData:this.props.cityDetailsByState}) 
      } 
      this.setState({statesName:nextProps.states})
      isLoading='false';
    }
     
   if(this.props.cityDetailsByState !== nextProps.cityDetailsByState){
      this.setState({citiesData:nextProps.cityDetailsByState})
      isLoading='false';
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        isLoading='false';
      }
    }
  }

  componentWillUpdate(nextProps, nextState, prevState, prevProps) {
    if(this.state.country !== nextState.country) {
      nextProps.onSelectedCountry(nextState.country, nextState.countryName);
    }
      
    if(this.state.state !== nextState.state ) {
      nextProps.onSelectedState(nextState.state, nextState.stateName);
    }
    if(this.state.city !== nextState.city ) {
      if(nextState.cityID !== undefined){
        nextProps.onSelectedCity(nextState.city, nextState.cityID);
      }
    }
  }

  render() {
    let countrydata= (this.state.countryData) ? this.state.countryData : [];
    let countryItems;
    
    if(countrydata){
      countryItems= countrydata.map((countryObject, index) =>
      <option key={index} value={countryObject.country}>{countryObject.countryName}</option>
      );
    }
    

    let statedata= (this.state.statesName) ? this.state.statesName : [];
    let stateItems;
    
    if (statedata){
      stateItems = statedata.map((stateObject, index) =>
        <option key={index} value={stateObject.stateAbbr}>{stateObject.state}</option>
      );
    }
    
    let citiesdata= (this.state.citiesData) ? this.state.citiesData : [];
    if (citiesdata){
      cityItems = citiesdata.map((cityObject, index) =>
        <option key={index} value={cityObject.title}>{cityObject.title}</option>
      );
    }
    return (
       <div className="city">  
            {(isLoading =='true') ?
            
            <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
            </div> : ''
            }
            <div className="form-group" id="countryField">
              <label htmlFor="country"> {(this.state.countrybg=="")?
              <span style={{color: "red"}}>*</span>:""} Country
              </label>
              <select name="country" className="form-control" style={{borderColor:this.state.countrybg}} value={(this.state.country) ? this.state.country : ''}  onChange={this.handlesOnCountryChanged}>
              <option>Select a country</option>
              {countryItems}
              </select>
            </div>

            <div className="form-group" id="stateField">
            <label htmlFor="state"> {(this.state.statebg=="")?
            <span style={{color: "red"}}>*</span> :""} State
            </label>
            <select name="state"  className="form-control"  style={{borderColor:this.state.statebg}}  value={(this.state.state) ? this.state.state : ''}  onChange={this.handlesOnStateChanged}>
            <option>Select a state</option>
            {stateItems}
           
            </select>
            </div>

            <div className="form-group" id="cityField">
            <label htmlFor="title"> {(this.state.citybg=="")?
            <span style={{color: "red"}}>*</span> :""} City
            </label>
            <select name="title" className="form-control" value={(this.state.city) ? this.state.city : ''}  style={{borderColor:this.state.citybg}}  onChange={this.handlesOnCityChanged}>
            <option>Select a city</option>
            {cityItems}
            
            </select>
            </div>
            
        </div>
    );
  }        

}

const mapStateToProps = (state,ownProps) => {
  return {
  countries :state.countryCityReducers.countries,
  states: state.countryCityReducers.states,
  cityDetailsByState: state.countryCityReducers.cityDetailsByState,
  error: state.countryCityReducers.error
  };
};

export default connect(mapStateToProps)(CountryStateCity);



// WEBPACK FOOTER //
// ./src/app/components/countryStateCity/CountryStateCity.js